import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import axios from "axios";
import auth from "@/auth";
import mixins from "@/mixins";
import wb from "@/registerServiceWorker";
import Buefy from "buefy";
import VueRouter from "vue-router";
import Vue2Filters from "vue2-filters";
import VueAuth from "@websanova/vue-auth";
import VueAxios from "vue-axios";
import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import "@/assets/_styles.scss";

Vue.config.productionTip = false;
Vue.prototype.$workbox = wb;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

// UI and Component
Vue.use(Buefy);
Vue.use(VueSidebarMenu);
Vue.use(Vue2Filters);

// Set Vue router
Vue.router = router;
Vue.use(VueRouter);

// Authentication
Vue.use(VueAxios, axios);
Vue.use(VueAuth, auth);

// Mixins
Vue.mixin(mixins);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
